/** Texto curto de um link de ticket: o último trecho do caminho (`ABC-1`) ou, sem caminho, o domínio. */
export function rotuloDoLink(link: string): string {
  try {
    const url = new URL(link);
    const ultimo = url.pathname.split('/').filter(Boolean).pop();
    return ultimo ? decodeURIComponent(ultimo) : url.host;
  } catch {
    return link;
  }
}
